import { ErrorMessage } from "@msys/ui";
import { useTranslate } from "@tolgee/react";

export const Forbidden = () => {
  const { t } = useTranslate(["Global"]);

  return <ErrorMessage message={t("Forbidden", { ns: "Global" })} />;
};
